var _path, _rect, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultiChannelUserMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "320 300 600 650",
    width: 24,
    height: 24,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 53.33,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M443 774 H412 Q380 774 380 742 V376.7 Q380 336.7 420 336.7 H670 Q709 336.7 709 375.7 V433",
    strokeLinecap: "butt"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 503,
    y: 474,
    width: 349,
    height: 411,
    rx: 33
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M588 590 H768 M588 683 H768 M588 773 H768"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiChannelUserMessage);
export default __webpack_public_path__ + "static/media/multi-channel-user-message.78b5463e8910184b32bc46a7e114ac90.svg";
export { ForwardRef as ReactComponent };